export enum MovieSeriesStatus {
	COMING_SOON = "COMING_SOON",
	PLAYING = "PLAYING",
	ENDED = "ENDED",
}

export const MovieSeriesStatusOptions = [
	{ value: MovieSeriesStatus.COMING_SOON, label: "به زودی" },
	{ value: MovieSeriesStatus.PLAYING, label: "در حال پخش" },
	{ value: MovieSeriesStatus.ENDED, label: "تمام شده" },
] as const;
